import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react'; // this is not optional!
import log from './logging';
import { Provider } from 'react-redux';
import { HeadProvider } from 'react-head';
import { PersistGate } from 'redux-persist/lib/integration/react';
// CSS stuff (ATTENTION: ORDER MATTERS IN PRODUCTION MODE!!!)
import 'libjs/semantic-ui-css/semantic.css';
import './styles/main.scss';
import { View, BootLoader } from './templating/view';
log.startup('creating App and initializing ...');
//XXX: use a ErrorBoundary toplevel here?
const BrowserApp = ({ store, persistor })=>/*#__PURE__*/ _jsx(PersistGate, {
        persistor: persistor,
        loading: /*#__PURE__*/ _jsx(BootLoader, {}),
        children: /*#__PURE__*/ _jsx(Provider, {
            store: store,
            children: /*#__PURE__*/ _jsx(HeadProvider, {
                children: /*#__PURE__*/ _jsx(View, {})
            })
        })
    });
const ExpressApp = (store, headTags = [])=>/*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: /*#__PURE__*/ _jsx(HeadProvider, {
            headTags: headTags,
            children: /*#__PURE__*/ _jsx(View, {})
        })
    });
export { BrowserApp, ExpressApp };
